import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";

import {
  fetchEnforcementSettings,
  setEnforcementSettings,
} from "actions/settings";
import { IRootStateProps } from "types/reducers";
import { RequestStatus } from "types/requests";

import SettingsPage from "components/settings/settings_page";

interface IPropsFromState {
  permalink: string;
  enforcementOn: boolean;
  gracePeriod: number;
  enforcementRequestStatus: RequestStatus;
}

interface ISettingsContainerProps extends RouteComponentProps<{
  permalink: string;
}> {}

interface IMapDispatchToProps {
  fetchEnforcementSettings: (permalink: string) => void;
  setEnforcementSettings: (
    permalink: string,
    enforcementOn: boolean,
    gracePeriod: number
  ) => void;
}

const mapStateToProps = (
  state: IRootStateProps,
  ownProps: ISettingsContainerProps
): IPropsFromState => {
  const {
    enforcementOn,
    gracePeriod,
    requests: { enforcementRequestStatus },
  } = state.settings;
  const { permalink } = ownProps.match.params;
  return { enforcementOn, gracePeriod, permalink, enforcementRequestStatus };
};

const mapDispatchToProps: IMapDispatchToProps = {
  fetchEnforcementSettings,
  setEnforcementSettings,
};

const SettingsContainer = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SettingsPage)
);

export default SettingsContainer;
